module.exports = __webpack_public_path__ + "static/media/icita2014.52ad61e4.png";